import { useEffect, useState } from "react";
import axiosInstance from "../utils/axiosInstance";

const ScrollingBanner = () => {
    const [bannerText, setBannerText] = useState(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const fetchBannerText = async () => {
            try {
                const response = await axiosInstance.get("/application-configuration");
                const headerBannerText = response.data.header_banner_text;
                if (headerBannerText) {
                    setVisible(true);
                    setBannerText(headerBannerText);
                }
            } catch (error) {
                console.error("Failed to fetch banner text", error);
            }
        };
        fetchBannerText();
    }, []);

    if (!visible) return null;

    return (
        <div className="relative overflow-hidden h-12 flex items-center animate-backgroundChange dark:animate-backgroundChangeDark dark:bg-gray-800 z-1">
            <div className="animate-scroll whitespace-nowrap text-white text-sm sm:text-base md:text-lg font-semibold px-4 sm:px-6 lg:px-8 hover:[animation-play-state:paused]">
                {bannerText}
            </div>
            <button
                onClick={() => setVisible(false)}
                className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 text-white text-lg sm:text-2xl p-2 touch-manipulation hover:text-gray-300"
                aria-label="Close Banner"
            >
                ×
            </button>
        </div>
    );
};

export default ScrollingBanner;